import { gql } from '@apollo/client';

export const BIN_CONTROLLER_SENSOR_STATUS_GQL = gql`
  query BinControllerSensorStatus($deviceId: uuid!) {
    bin_controller(
      where: { device_id: { _eq: $deviceId }, deleted_at: { _is_null: true } }
      limit: 1
    ) {
      id
      device_id
      bin_set {
        feed_lines(where: { deleted_at: { _is_null: true } }) {
          id
          name
          device_assignments(
            where: { deleted_at: { _is_null: true }, ended_at: { _is_null: true } }
          ) {
            device {
              id
              serial
              type
              lastTransaction: transactions(order_by: { occured_at: desc }, limit: 1) {
                occured_at
                status
              }
            }
          }
        }
      }
      device {
        serial
        last_reset: faults(
          where: { code: { _eq: 1001 }, deleted_at: { _is_null: true } }
          order_by: { created_at: desc }
          limit: 1
        ) {
          started_at
          details
        }
        lan_events: faults(
          where: { code: { _in: [1103, 1104] }, deleted_at: { _is_null: true } }
          order_by: { created_at: desc }
          limit: 750
        ) {
          id
          code
          started_at
          ended_at
          details
        }
      }
    }
  }
`;
